import { graphql, HttpResponse } from 'msw';
import type {
  FinalizeFanSuperMessagePurchaseByCreditCardMutation,
  FinalizeFanSuperMessagePurchaseByCreditCardMutationVariables,
} from '@/__generated__/graphql';

export const finalizeFanSuperMessagePurchaseByCreditCard = graphql.mutation<
  FinalizeFanSuperMessagePurchaseByCreditCardMutation,
  FinalizeFanSuperMessagePurchaseByCreditCardMutationVariables
>('FinalizeFanSuperMessagePurchaseByCreditCard', () => {
  return HttpResponse.json({
    data: {
      __typename: 'Mutation',
      finalizeFanSuperMessagePurchaseByCreditCard: {
        __typename: 'FinalizeFanSuperMessagePurchaseByCreditCardPayloadSuccess',
        paymentOrderID: `mock-payment-order-${Date.now()}`,
        ok: true,
      },
    },
  });
});
